<button class="exit-delegation" (click)="cancelDelegation($event)">
  {{ "labels.EXIT" | translate }}
</button>
